import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)
Vue.config.productionTip = false

new Vue({
  vuetify: new Vuetify({
    theme: {
      dark: false,
      themes: {
        light: {
          primary: '#487484',
          secondary: '#2CAAE0',
          accent: '#FAFAFA',
          error: '#f44336',
          warning: '#ff5722',
          info: '#03a9f4',
          success: '#4caf50',
          text: '#4A4A4A'
        },
        dark: {
          primary: '#9c27b0',
          secondary: '#673ab7',
          accent: '#3f51b5',
          error: '#f44336',
          warning: '#ff5722',
          info: '#03a9f4',
          success: '#4caf50'
        }
      }
    }
  }),
  router,
  store,
  render: h => h(App)
}).$mount('#app')
